import { render, staticRenderFns } from "./QuizsetMain.vue?vue&type=template&id=405ae802&"
import script from "./QuizsetMain.vue?vue&type=script&lang=js&"
export * from "./QuizsetMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports